export default class ConnectionManager {
    game = null;
    usersInChannel = [];
    cpu = false;

    onGetData = function(){};
    onGetSingleScore = function(){};
    onNextPlayer = function(){};

    onGetScreenshot = function(){};

    onWarningPlayerNotHere = function() {};
    onSuccessPlayersHere = function() {};

    constructor(game, playercount) {
        this.game = game;
        this.playercount = playercount;
        this.setCurrentGame();
        Echo.private('games.' + game.id)
            .listen('.game.sendlegcontent', (e) => {
                this.sendlegcontent(e)
            })
            .listen('.game.sendsinglescore', (e) => {
                this.sendsinglescore(e)
            })
            .listen('.game.nextplayer', (e) => {
                this.nextplayer(e)
            })
            .listen('.game.sensor', (e) => {
                this.sensor(e)
            })
            .listen('.game.getscreenshot', (e) => {
                this.getscreenshot(e)
            })
            .listen('.game.proposerematch', (e) => {
                this.proposeRematch(e)
            })
            .listen('.game.abortmatch', (e) => {
                this.abortMatch(e)
            })
            //only use gamestate channel if playing against real opponents
        Echo.join('gamestate.' + game.id)
            .here(users => {
                if (this.cpu) return;
                this.usersInChannel= users;
                this.forceRefresh();
                if (!this.checkAllPlayersInGame()) this.sendWarningPlayerNotHere();
                else this.sendSuccessPlayersHere();
            })
            .joining(user => {
                if (this.cpu) return;
                this.usersInChannel.push(user);
                if (!this.checkAllPlayersInGame()) this.sendWarningPlayerNotHere();
                else this.sendSuccessPlayersHere();
                this.forceRefresh();
            })
            .leaving(user => {
                if (this.cpu) return;
                //removes the user
                this.usersInChannel = this.usersInChannel.filter(function(el) { return el.id != user.id; });
                if (!this.checkAllPlayersInGame()) this.sendWarningPlayerNotHere();
                else this.sendSuccessPlayersHere();
                this.forceRefresh();
            })
    }

    playAgainstCpu() {
        this.cpu = true;
        setTimeout((e) => {
            this.forceRefresh();
        }, 1000)
    }

    forceRefresh() {
        axios.get("/api/games/" + this.game.id + "/getlegcontent"); //tells the server to load the current game progress after channel has been established
    }

    sendlegcontent(e) {
        this.onGetData(e)
    }

    sendsinglescore(e) {
        this.onGetSingleScore(e)
    }

    nextplayer(e) {
        this.onNextPlayer(e)
    }

    sensor(e) {
        this.onSensor(e)
    }

    getscreenshot(e) {
        this.onGetScreenshot(e)
    }

    checkAllPlayersInGame() {
        console.log(this.playercount);
        if (this.usersInChannel.length >= this.playercount) return true;
        else return false;
    }

    sendWarningPlayerNotHere(e) {
        this.onWarningPlayerNotHere(e);
    }

    sendSuccessPlayersHere(e) {
        this.onSuccessPlayersHere(e);
    }

    //sets the current game as the current game id on the user for using client to send to the correct game id
    setCurrentGame() {
        axios.post("/api/users/current_game/" + this.game.id);
    }

    proposeRematch(e) {
        this.onProposeRematch(e);
    }

    abortMatch(e) {
        this.onAbortMatch(e);
    }
}
